import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Room from './Room';
import FloorPlan from './FloorPlan';
import Modal from '@mui/material/Modal';
import {
    lockerRoom,
    staffRoom,
    wetStoreRoom,
    kitchen,
    livingArea,
    staircase,
    openArea,
    restRooms,
    officeRoom,
    elevation,
    homeFront,
    nursing,
    library,
    dining,
    reception
} from '../constants/lockerRoom';
import { getBuilding } from '../services/booking.db';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                children
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const objectToArray = (data) => {
    return Object.keys(data).map(key => ({ id: key, ...data[key] }));
}
export default function BasicTabs() {
    const [value, setValue] = React.useState(0);
    const [buildingData, setBuildingData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getBuilding(_buildingData => {
            let buildingPlan = {
                locker: { ...lockerRoom },
                staff: { ...staffRoom },
                store: { ...wetStoreRoom },
                kitchen: { ...kitchen },
                nursing: { ...nursing },
                staircase: { ...staircase },
                open: { ...openArea },
                living: { ...livingArea },
                rest: { ...restRooms },
                dining: { ...dining },
                library: { ...library },
                office: { ...officeRoom },
                reception: { ...reception },
                elevation: { ...elevation },
                front: { ...homeFront },
            };
            Object.keys(_buildingData).forEach(key => {
                const rows = objectToArray(_buildingData[key]);

                Object.keys(_buildingData[key]).forEach(rowIndex => {
                    Object.keys(_buildingData[key][rowIndex]).forEach(colIndex => {
                        buildingPlan[key].tiles[rowIndex][colIndex].type = _buildingData[key][rowIndex][colIndex].type;
                    })
                })
            })
            console.log(buildingPlan)
            setBuildingData(buildingPlan)
            setLoading(false);
        });
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    if (loading) {
        return <Modal
            open={loading}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        ><div style={
            {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }
        }>
                <CircularProgress />
            </div></Modal>
    }
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile>
                    <Tab label="All Rooms" {...a11yProps(0)} />
                    <Tab label="Locker Room" {...a11yProps(1)} />
                    <Tab label="Staff Room" {...a11yProps(2)} />
                    <Tab label="Wet-Store Room" {...a11yProps(3)} />
                    <Tab label="Kitchen" {...a11yProps(4)} />
                    <Tab label="Nursing Bay" {...a11yProps(5)} />
                    <Tab label="Staircase" {...a11yProps(6)} />
                    <Tab label="Open Area" {...a11yProps(7)} />
                    <Tab label="Living Area" {...a11yProps(8)} />
                    <Tab label="Rest Rooms" {...a11yProps(9)} />
                    <Tab label="Dining" {...a11yProps(10)} />
                    <Tab label="Library" {...a11yProps(11)} />
                    <Tab label="Office Room" {...a11yProps(12)} />
                    <Tab label="Reception" {...a11yProps(13)} />
                    <Tab label="Elevator Area" {...a11yProps(14)} />
                    <Tab label="Home Front Area" {...a11yProps(15)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <FloorPlan onRoomClick={handleChange} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Room data={buildingData.locker} backgroundColor="#fad2a7" />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <Room data={buildingData.staff} backgroundColor="#fbeac8" />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <Room data={buildingData.store} backgroundColor="#b1d9cd" />
            </TabPanel>
            <TabPanel value={value} index={4}>
                <Room data={buildingData.kitchen} backgroundColor="#93c2c6" />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <Room data={buildingData.nursing} backgroundColor="#9fc4e1" />
                {/* todo */}
            </TabPanel>
            <TabPanel value={value} index={6}>
                <Room data={buildingData.staircase} backgroundColor="#f8dacd" />
            </TabPanel>
            <TabPanel value={value} index={7}>
                <Room data={buildingData.open} backgroundColor="#9a8d99" />
            </TabPanel>
            <TabPanel value={value} index={8}>
                <Room data={buildingData.living} backgroundColor="#fdb196" />
            </TabPanel>
            <TabPanel value={value} index={9}>
                <Room data={buildingData.rest} backgroundColor="#f7bbbc" />
            </TabPanel>
            <TabPanel value={value} index={10}>
                <Room data={buildingData.dining} backgroundColor="#9a8d99" />
                {/* todo */}
            </TabPanel>
            <TabPanel value={value} index={11}>
                <Room data={buildingData.library} backgroundColor="#9a8d99" />
                {/* todo */}
            </TabPanel>
            <TabPanel value={value} index={12}>
                <Room data={buildingData.office} backgroundColor="#f8e4db" />
            </TabPanel>
            <TabPanel value={value} index={13}>
                <Room data={buildingData.reception} backgroundColor="#9a8d99" />
                {/* todo */}
            </TabPanel>
            <TabPanel value={value} index={14}>
                <Room data={buildingData.elevation} backgroundColor="#d9b8be" />
            </TabPanel>
            <TabPanel value={value} index={15}>
                <Room data={buildingData.front} backgroundColor="#9fc4e1" />
            </TabPanel>
        </Box >
    );
}
